export function formatCurrency(amount){

    if(!amount){

        return "₹0";

    }

    return new Intl.NumberFormat(

        "en-IN",

        {

            style:"currency",

            currency:"INR",

            maximumFractionDigits:0

        }

    ).format(amount);

}